import * as React from 'react';

const InfoCircle12 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 12 12", width: 12, height: 12, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 1.5a4.5 4.5 0 0 1 4.5 4.49 4.51 4.51 0 0 1-4.5 4.5 4.51 4.51 0 0 1-4.5-4.5A4.5 4.5 0 0 1 6 1.5M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0m.6 5.25H5.4V8.5h1.2zM5.47 3.21A.75.75 0 0 1 6 2.99a.76.76 0 0 1 .75.75.75.75 0 0 1-.75.75.74.74 0 0 1-.75-.75.75.75 0 0 1 .22-.53",
    clipRule: "evenodd"
  }
));
InfoCircle12.Size = 12;
InfoCircle12.Title = "InfoCircle";

export { InfoCircle12 as default };
